import * as React from "react";
export default class TabGroup extends React.Component {
    constructor(props) {
        super(props);
        this.updateTabIndex = (i) => {
            this.setState({ tabIndex: i });
        };
        this.state = {
            tabIndex: this.props.tabObjs.length ? this.props.tabObjs[0].id : 0
        };
    }
    render() {
        return (React.createElement("div", { className: "tab-group" },
            React.createElement("nav", { className: "tabs" },
                React.createElement("ul", null, this.props.tabObjs.map((tabObj, index) => {
                    return React.createElement("li", { key: index, className: tabObj.id === this.state.tabIndex ? "tab active" : "tab", onClick: () => { this.updateTabIndex(tabObj.id); } }, tabObj.tabHeader);
                }))),
            React.createElement("div", { className: "tab-content" }, this.props.tabObjs[this.state.tabIndex].tabContent)));
    }
}
;
//# sourceMappingURL=tab-group.js.map